import { isIOS, isSafari } from 'react-device-detect';
import AppleAudioPlayer from './AppleAudioPlayer';
import AudioSegmentPlayer from './AudioSegmentPlayer';
import { isSegmentable } from './Segmentable';

const Player = isIOS || isSafari ? AppleAudioPlayer : AudioSegmentPlayer;

export { isSegmentable, Player as AudioPlayer };
